import type { PropsWithChildren } from 'react';

import { getFormattedLocalizedDateTimeWithSeconds } from '$shared/utils/date.utils';

type IncidentDetailFinalStateProps = PropsWithChildren<{
  timestamp: number | undefined;
}>;

export function IncidentDetailFinalState({
  timestamp,
  children,
}: IncidentDetailFinalStateProps) {
  return (
    <div className="flex gap-l flex__dir--column flex__ai--center">
      <div className="flex gap-m flex__dir--column text-align-center">
        {timestamp && <time>{getFormattedLocalizedDateTimeWithSeconds(timestamp)}</time>}
      </div>
      <div>{children}</div>
    </div>
  );
}
